import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from './CartContext';
import emailjs from 'emailjs-com';
import './Shipping.css';

function Shipping() {
  const { formData, cartItems } = useCart();
  const navigate = useNavigate();

  const [selectedDelivery, setSelectedDelivery] = useState('');
  const [selectedPayment, setSelectedPayment] = useState('');
  const [selectedLocker, setSelectedLocker] = useState('');

  const handleDeliveryClick = (method) => {
    setSelectedDelivery(method);
  };

  const handlePaymentClick = (method) => {
    setSelectedPayment(method);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const shippingData = {
      MetodaPłatności: selectedPayment,
      MetodaDostawy: selectedDelivery,
      Paczkomat: selectedDelivery === 'inpost' ? selectedLocker : '',
    };

    const combinedData = {
      Imię: formData.firstName,
      Nazwisko: formData.lastName,
      Miasto: formData.city,
      Ulica: formData.street,
      'Numer domu': formData.houseNumber,
      'Kod pocztowy': formData.postalCode,
      'Numer telefonu': formData.phoneNumber,
      Email: formData.email,
      ...shippingData,
      'Produkty w koszyku': cartItems
        .map((item) => `${item.name} x${item.quantity} (${item.totalPrice} zł)`)
        .join(', '), 
    };

    const fileContent = Object.entries(combinedData)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');
    const blob = new Blob([fileContent], { type: 'text/plain' });
    const fileUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'dane_zamówienia.txt';
    link.click();

    emailjs
      .send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', combinedData, 'YOUR_USER_ID')
      .then(() => {
        alert('Dane zostały wysłane na maila!');
        navigate('/'); 
      })
      .catch((error) => {
        console.error('EmailJS Error:', error);
        alert('Wystąpił błąd podczas wysyłania danych.');
      });
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="navbar">
          <div className="logo">
            <img src="/logo.png" alt="logo" />
          </div>
          <div className="brand-name">Cozy Fang</div>
          <nav>
            <ul className="menu">
              <li className="home"><a href="/">Home</a></li>
              <li><a href="/store">Store</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </nav>
        </div>
      </header>

      <div className="shipping" style={{ backgroundColor: 'white', padding: '20px', marginTop: '100px', flex: 1 }}>
        <h1>Szczegóły Płatności i Dostawy</h1>
        <form onSubmit={handleSubmit}>
          <div className="segment">
            <h2>Płatność</h2>
            <div className="options">
              {['przelewy24', 'googlepay', 'blik', 'visa'].map((method) => (
                <label
                  key={method}
                  className={selectedPayment === method ? 'selected' : ''}
                  onClick={() => handlePaymentClick(method)}
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    value={method}
                    checked={selectedPayment === method}
                    onChange={() => handlePaymentClick(method)}
                  />
                  {method === 'przelewy24' && <img src="/przelewy24_logo.png" alt="Przelewy24" />}
                  {method === 'googlepay' && <img src="/google-pay.png" alt="Google Pay" />}
                  {method === 'blik' && <img src="/Blik-logo.png" alt="BLIK" />}
                  {method === 'visa' && <img src="/visa.png" alt="VISA" />}
                  {method.toUpperCase()}
                </label>
              ))}
            </div>
          </div>

          <div className="segment">
            <h2>Sposób dostawy</h2>
            <div className="options">
              <label
                className={selectedDelivery === 'kurier' ? 'selected' : ''}
                onClick={() => handleDeliveryClick('kurier')}
              >
                <input
                  type="radio"
                  name="deliveryMethod"
                  value="kurier"
                  checked={selectedDelivery === 'kurier'}
                  onChange={() => handleDeliveryClick('kurier')}
                />
                Kurier
              </label>
              <label
                className={selectedDelivery === 'inpost' ? 'selected' : ''}
                onClick={() => handleDeliveryClick('inpost')}
              >
                <input
                  type="radio"
                  name="deliveryMethod"
                  value="inpost"
                  checked={selectedDelivery === 'inpost'}
                  onChange={() => handleDeliveryClick('inpost')}
                />
                InPost Paczkomat
              </label>
              {selectedDelivery === 'inpost' && (
                <select
                  name="locker"
                  value={selectedLocker}
                  onChange={(e) => setSelectedLocker(e.target.value)}
                  required
                >
                  <option value="">Wybierz paczkomat</option>
                  <option value="Paczkomat A">Paczkomat A</option>
                  <option value="Paczkomat B">Paczkomat B</option>
                  <option value="Paczkomat C">Paczkomat C</option>
                </select>
              )}
              <label
                className={selectedDelivery === 'odbior_osobisty' ? 'selected' : ''}
                onClick={() => handleDeliveryClick('odbior_osobisty')}
              >
                <input
                  type="radio"
                  name="deliveryMethod"
                  value="odbior_osobisty"
                  checked={selectedDelivery === 'odbior_osobisty'}
                  onChange={() => handleDeliveryClick('odbior_osobisty')}
                />
                Odbiór osobisty
              </label>
            </div>
          </div>

          <button type="submit" id="zatwierdz"><span>Zatwierdź</span></button>
        </form>
      </div>

      <div className="Footer">
        <img src="/logo.png" alt="Logo" />
      </div>
      <div className="Footer-bar">
        <div className="footer-left">
          COZY FANG 2025 <br />
          WSZELKIE PRAWA ZASTRZEŻONE
        </div>
        <div className="footer-icons">
          <img src="/ig.png" alt="Instagram" />
          <img src="/fb.png" alt="Facebook" />
          <img src="/yt.png" alt="YouTube" />
        </div>
        <div className="footer-right">
          <a href="/regulamin">REGULAMIN</a>
          <a href="/polityka-prywatnosci">POLITYKA PRYWATNOŚCI</a>
        </div>
      </div>
    </div>
  );
}

export default Shipping;
